import Vue from 'vue';
import Vuex from 'vuex';
import { authMenuApi, getUserInfo } from '../api/auth';
import { SET_CONTENT_CLASS } from './mutationTypes';

// 需要隐藏的菜单标识
const hideMenuCodes = ['console.fault.realtime'];

const state = {
  userAuthorities: [],
  contentClass: 'bg-white',
};
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((module, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  module[moduleName] = value.default;
  return module;
}, {});
Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  modules,
  mutations: {
    [SET_CONTENT_CLASS](states, newValue) {
      Object.assign(states, { contentClass: newValue });
    },
    setUserAuthorities(stateObj, newValue) {
      const states = stateObj;
      states.userAuthorities = newValue;
    },
  },
  actions: {
    async updateUserAuthorities({ commit }) {
      const resData = await authMenuApi({}, { meta: { auth: 0 } });
      const list = resData.data.list || [];
      const userAuthorities = list.filter((item) => !hideMenuCodes.some((code) => code === item.action));
      commit('setUserAuthorities', userAuthorities);
      return userAuthorities;
    },
    async refreshToken() {
      await getUserInfo({});
    },
  },
});

export default store;
